import type { NDateLocale } from './enUS'
import { eo } from 'date-fns/locale'

const dateEo: NDateLocale = {
  name: 'eo',
  locale: eo
}

export default dateEo
